import styled from 'styled-components';

export const Container = styled.div`
	max-width: 96rem;
	//width: 100%;
	margin: auto;
	min-height: 100dvh;
	display: flex;
	flex-direction: column;
	padding: 0 4rem 15rem;
`;
